import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { forwardRef, useImperativeHandle } from 'react';
import CardForm from "./CardForm";

const stripeKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
const stripePromise = stripeKey ? loadStripe(stripeKey) : null;


interface CardDetails {
  id: string;
  brand: string;
  last4: string;
  expMonth: number;
  expYear: number;
  isDefault: boolean;
}

const PaymentCard = forwardRef(({ onSubmit, isError, errorText }: { onSubmit: (values: any) => void, isError: boolean, errorText: string }, ref: React.Ref<any>): JSX.Element => {
  const cardFormRef = React.useRef<any>(null);

  useImperativeHandle(ref, () => ({
    async processPayment() {
      if (cardFormRef.current) {
        const paymentMethodId = await cardFormRef.current.processPayment();
        return paymentMethodId;
      }
      return null;
    }
  }));


  return (
      stripePromise ? (
        <Elements stripe={stripePromise}>
          <CardForm ref={cardFormRef} onSubmit={onSubmit} isError={isError} errorText={errorText} />
        </Elements>
      ) : <></>
  );
});

export default PaymentCard;
